export default function identity(): void;
export default function identity<T>(value: T): T;
export default function identity<T>(value?: T): T {
    return value as T;
}
